/* This file was automatically generated - please modify the template not this file! */

import * as React from "react";

import { Grid } from "semantic-ui-react";

import { AppState, OrgStructureDetailModel } from "@teamprevent/common/orgStructure/models";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { loadOrgStructureDetail } from "../actions";

import { All } from "./All";

export interface CoreDetailProps {
    orgStructure: OrgStructureDetailModel;
}

export const Detail: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const orgStructure = useSelector((state: AppState) => state.orgStructure);
    const customerId = useSelector((state: AppState) => state.router.params.customerId);
    const orgStructureOneId = useSelector((state: AppState) => state.router.params.orgStructureOneId);
    const orgStructureTwoId = useSelector((state: AppState) => state.router.params.orgStructureTwoId);
    const orgStructureThreeId = useSelector((state: AppState) => state.router.params.orgStructureThreeId);
    const orgStructureFourId = useSelector((state: AppState) => state.router.params.orgStructureFourId);

    React.useEffect(() => {
        dispatch(loadOrgStructureDetail({ customerId, orgStructureOneId, orgStructureTwoId, orgStructureThreeId, orgStructureFourId }));
    }, [customerId, dispatch, orgStructureFourId, orgStructureOneId, orgStructureThreeId, orgStructureTwoId]);

    if (!orgStructure) {
        return null;
    }

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column>
                    <All orgStructure={orgStructure} />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
